module.exports = __webpack_public_path__ + "static/img/new_thumb1.d890c50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new_thumb1.jpg
// module id = NHVZ
// module chunks = 0